import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Xacnhanhopdong from "components/Xacnhanhopdong/Xacnhanhopdong.js";
import Huyxacnhanhopdong from "components/Xacnhanhopdong/Huyxacnhanhopdong.js";
export default function XNhopdong() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Xác nhận hợp đồng",
            tabContent: <Xacnhanhopdong />,
          },
          {
            tabName: "Hủy xác nhận hợp đồng",
            tabContent: <Huyxacnhanhopdong />,
          },
        ]}
      />
    </div>
  );
}
